import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = [
  "Recruitment",
  "Compliance",
  "Payroll",
  "Culture",
  "Leadership",
  "Onboarding",
  "Retention",
  "Benefits",
];

export const EditorialMarquee = () => {
  return (
    <section data-testid="marquee-section" className="bg-primary text-primary-foreground py-8 overflow-hidden">
      <Marquee speed={45} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-display italic text-3xl md:text-4xl px-8">{w}</span>
            <span className="h-2 w-2 rounded-full bg-accent" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};
